export const timeToSeconds = (timeStr: string) => {
    const [hours, minutes, seconds] = timeStr.split(':').map(Number);

    return hours * 3600 + minutes * 60 + seconds;
};

export const formatTime = (s: number) => {
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const secs = Math.floor(s % 60);

    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const parseVideoStartTime = (fileName?: string): number => {
    if (!fileName) { return 0; }
    const match = fileName.match(/_(\d{2})_(\d{2})_(\d{2})/); // ищем "_12_03_41"
    if (!match) { return 0; }

    const [, hh, mm, ss] = match.map(Number);

    return hh * 3600 + mm * 60 + ss; // секунды от начала дня
};
